import { useState, useEffect } from "react";
import { faHeart as faHeartO } from "@fortawesome/free-regular-svg-icons";
import { faHeart, faCartShopping, faHardDrive, faMicrochip, faCamera, faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getWishListItems, loadCartItems } from "../../_helpers/cart.methods";
import { IconList } from "../../_helpers/detail-icons";
import { propretiesMap } from "../../../_helpers/mock-data";


export const GradeCard = ({ data }) => {

    const makeProp = (name) => {
        return propretiesMap[name] ? propretiesMap[name].fr : name;
    }

    return (
        <div className="properties-list grade-card">
            {data?.properties?.map((prop, k) => (
                <div className="prop-list-row" key={k}>

                    <div className="prop-data-box">
                        <span className="prop-title">{makeProp(Object.keys(prop)[0])}</span>
                        <span className="prop-data">{Object.values(prop)[0]}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}